module.exports = "div.w3-card {\r\n    width: 95%;\r\n    max-width: 500px;\r\n}\r\n\r\n.login-container {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n\r\n    position: absolute;\r\n    top: -2.5rem;\r\n    left: 0;\r\n\r\n    height: 100vh;\r\n    width: 100vw;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.component.css
// module id = ./src/app/components/login/login.component.css
// module chunks = main